(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    function getPremiumCoverLabel(value) {
    switch (value) {
      case 'Cover Story':
        return 'Cover Story';
      default:
        return value || '';
    }
  }

  function getPremiumFormatCopy(scope, variant) {
    if (!scope) return null;

    const formatFieldset = scope.querySelector('.variant-option--premium-format');
    if (!formatFieldset) return null;

    let formatInput = null;
    const selectedFormat = variant?.option1 || '';

    if (selectedFormat) {
      if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
        formatInput = formatFieldset.querySelector(`input[value="${CSS.escape(selectedFormat)}"]`);
      }

      if (!formatInput) {
        formatInput = [...formatFieldset.querySelectorAll('input')].find((input) => input.value === selectedFormat) || null;
      }
    } else {
      formatInput = formatFieldset.querySelector('input:checked');
    }

    if (!(formatInput instanceof HTMLInputElement)) return null;

    return {
      description: formatInput.dataset.premiumFormatHelper || '',
      size: formatInput.dataset.premiumFormatSize || '',
    };
  }

  function updatePremiumHardcoverSummary(scope, variant) {
    if (!scope || !variant) return;

    const formatDescription = scope.querySelector('[data-premium-format-description]');
    const formatSize = scope.querySelector('[data-premium-format-size]');
    const selectedCover = scope.querySelector('[data-premium-selected-cover]');
    const addToCartLabel = scope.querySelector('.buy-buttons-block .add-to-cart-text__content span span');
    const formatCopy = getPremiumFormatCopy(scope, variant);
    const productHandle = scope.dataset.premiumProductHandle || '';
    const addToCartCopy =
      productHandle === 'classic-framed-print' || productHandle === 'edition-framed-print'
        ? 'Create your piece'
        : 'Create your book';

    if (formatDescription) formatDescription.textContent = formatCopy?.description || '';
    if (formatSize) formatSize.textContent = formatCopy?.size || '';

    if (selectedCover) selectedCover.textContent = getPremiumCoverLabel(variant.option2);
    if (addToCartLabel) addToCartLabel.textContent = addToCartCopy;
  }

  function initPremiumHardcoverProductInformation(section) {
    if (!section || section.dataset.premiumHardcoverInitialized === 'true') return;
    section.dataset.premiumHardcoverInitialized = 'true';

    const accordionRoot = section.querySelector('[data-premium-pdp-accordions]');
    if (accordionRoot && accordionRoot.dataset.enhanced !== 'true') {
      accordionRoot.dataset.enhanced = 'true';
      accordionRoot.classList.add('is-enhanced');

      const items = [...accordionRoot.querySelectorAll('.silvergrain-pdp-accordion')];
      const setExpandedHeight = (item) => {
        const panel = item.querySelector('.silvergrain-pdp-accordion__panel');
        if (!(panel instanceof HTMLElement)) return;
        panel.style.maxHeight = item.classList.contains('is-active') ? `${panel.scrollHeight}px` : '0px';
      };

      items.forEach((item) => {
        const summary = item.querySelector('summary');
        const panel = item.querySelector('.silvergrain-pdp-accordion__panel');
        if (!(summary instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;

        if (item.hasAttribute('open')) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }

        let animationFrame = 0;

        const syncExpandedState = () => {
          summary.setAttribute('aria-expanded', item.classList.contains('is-active') ? 'true' : 'false');
        };

        const cancelAnimation = () => {
          if (animationFrame) {
            cancelAnimationFrame(animationFrame);
            animationFrame = 0;
          }
        };

        const expandItem = () => {
          cancelAnimation();
          item.open = true;
          item.classList.remove('is-closing');
          panel.style.maxHeight = '0px';
          item.classList.add('is-active');
          syncExpandedState();

          animationFrame = requestAnimationFrame(() => {
            panel.style.maxHeight = `${panel.scrollHeight}px`;
          });
        };

        const collapseItem = () => {
          cancelAnimation();
          item.classList.add('is-closing');
          panel.style.maxHeight = `${panel.scrollHeight}px`;
          item.classList.remove('is-active');
          syncExpandedState();

          animationFrame = requestAnimationFrame(() => {
            panel.style.maxHeight = '0px';
          });
        };

        panel.addEventListener('transitionend', (event) => {
          if (event.propertyName !== 'max-height') return;

          if (item.classList.contains('is-active')) {
            panel.style.maxHeight = `${panel.scrollHeight}px`;
            item.open = true;
          } else {
            item.open = false;
            item.classList.remove('is-closing');
          }
        });

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          if (item.classList.contains('is-active')) {
            collapseItem();
          } else {
            expandItem();
          }
        });

        syncExpandedState();
        setExpandedHeight(item);
      });

      window.addEventListener(
        'resize',
        () => {
          items.forEach((item) => setExpandedHeight(item));
        },
        { passive: true }
      );
    }

    const variantData = section.querySelector('.variant-picker script[type="application/json"]');
    if (variantData) {
      try {
        updatePremiumHardcoverSummary(section, JSON.parse(variantData.textContent));
      } catch (error) {
        console.error(error);
      }
    }

    section.addEventListener('variant:update', (event) => {
      updatePremiumHardcoverSummary(section, event.detail?.resource);
    });
  }

  document.querySelectorAll('.product-information--premium-hardcover').forEach((section) => {
    initPremiumHardcoverProductInformation(section);
  });
  } catch(e) { console.error(e); }
})();

})();
